import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/axios.config';
import { baseUrl } from '../../utils/url';
import { toast } from 'react-hot-toast';
import DataList from '../../components/DataList';

function DonorPartner() {
  const [donorPartners, setDonorPartners] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGetDonorPartner = async () => {
    try {
      setLoading(true);
      const { data } = await api.get('donor-partner');
      setDonorPartners(data.donorPartner);
    } catch (error) {
      console.error('Error fetching donor/partners:', error);
      toast.error('ডেটা লোড করতে সমস্যা হয়েছে');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const { data } = await api.delete(`donor-partner/${id}`);
      if (data.success) {
        toast.success(data.message);
        handleGetDonorPartner();
      }
    } catch (error) {
      toast.error(error.response?.data?.error || 'মুছে ফেলতে সমস্যা হয়েছে');
    }
  };

  const handleEdit = (id) => {
    navigate(`/dashboard/add-donor-partner/${id}`);
  };

  useEffect(() => {
    handleGetDonorPartner();
  }, []);

  // Define columns for the table
  const columns = [
    {
      key: 'imageUrl',
      label: 'ছবি',
      render: (value, item) => (
        <div className="avatar">
          <div className="w-16 h-16 rounded-full ring ring-primary ring-offset-2">
            <img
              src={`${baseUrl}${value}`}
              alt={item.name}
              className="object-cover"
            />
          </div>
        </div>
      ),
    },
    {
      key: 'name',
      label: 'নাম',
      render: (value) => <span className="font-semibold text-gray-800">{value}</span>,
    },
    {
      key: 'designation',
      label: 'পদবী',
      render: (value) => (
        <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm">
          {value}
        </span>
      ),
    },
    {
      key: 'institute',
      label: 'প্রতিষ্ঠান',
      render: (value) => <span className="text-gray-600">{value}</span>,
    },
    {
      key: 'links',
      label: 'যোগাযোগ',
      render: (_, item) => (
        <div className="flex flex-col gap-1">
          {item.facebookUrl && (
            <a
              href={item.facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-blue-600 hover:text-blue-800 transition-colors"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              Facebook
            </a>
          )}
          {item.webUrl && (
            <a
              href={item.webUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-green-600 hover:text-green-800 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
              </svg>
              Website
            </a>
          )}
          {item.emailUrl && (
            <a
              href={`mailto:${item.emailUrl}`}
              className="flex items-center gap-1 text-purple-600 hover:text-purple-800 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Email
            </a>
          )}
          {!item.facebookUrl && !item.webUrl && !item.emailUrl && (
            <span className="text-gray-400 text-sm">-</span>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="p-6">
      <DataList
        data={donorPartners}
        columns={columns}
        title="ডোনার এন্ড পার্টনার"
        onEdit={handleEdit}
        onDelete={handleDelete}
        addButtonText="নতুন যুক্ত করুন"
        addButtonLink="/dashboard/add-donor-partner"
        loading={loading}
        emptyMessage="কোন ডোনার বা পার্টনার পাওয়া যায়নি"
        showSearch={true}
      />
    </div>
  );
}

export default DonorPartner;
